import { Link } from 'react-router-dom';
import type { Product } from '../types/products';
import Icon from './Icon';

interface ProductCardProps {
  product: Product;
  /** Optional quick-view handler (Product Finder). */
  onQuickView?: (product: Product) => void;
}

export default function ProductCard({ product, onQuickView }: ProductCardProps) {
  return (
    <div className="editorial-card group flex flex-col p-6">
      <div className="flex items-baseline justify-between gap-3">
        <span className="font-mono text-xs font-semibold tracking-wide text-primary">{product.code}</span>
        <span className="text-[0.7rem] uppercase tracking-wider text-secondary-dark">{product.group}</span>
      </div>
      <h3 className="mt-3 text-lg font-semibold leading-snug text-text-primary">{product.name}</h3>
      <p className="mt-2 line-clamp-3 flex-auto text-sm leading-6 text-text-secondary">
        {product.description}
      </p>
      <ul className="mt-4 space-y-1.5">
        {product.keyFeatures.slice(0, 2).map((f) => (
          <li key={f} className="flex items-start gap-2 text-xs text-text-secondary">
            <span className="mt-1.5 h-1 w-1 flex-none rounded-full bg-secondary" />
            {f}
          </li>
        ))}
      </ul>
      <div className="mt-5 flex items-center gap-4 border-t border-ink/10 pt-4">
        <Link
          to={`/products/${product.categorySlug}/${product.id}`}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary-dark"
        >
          View details
          <Icon name="arrow" className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
        {onQuickView && (
          <button
            type="button"
            onClick={() => onQuickView(product)}
            className="ml-auto inline-flex items-center gap-1.5 text-sm font-medium text-text-secondary hover:text-primary"
          >
            <Icon name="search" className="h-4 w-4" />
            Quick view
          </button>
        )}
      </div>
    </div>
  );
}
